(function($) {
	let blockwheelsAccordion = {
		initAll: function () {
			const $accordions = $('.wp-block-blockwheels-accordion');
			if (!$accordions || $accordions.length === 0) {
				return;
			}
			$accordions.map((index, accordion) => {
				let $accordion 	= $(accordion),
					$title 		= $accordion.find('.blockwheels-accordion-title-wrap');
				$title.on('click', function (e) {
					let dropDown = $(this).closest('.wp-block-blockwheels-accordion-panel').find('.blockwheels-accordion-content-wrap');
					$(this).closest('.wp-block-blockwheels-accordion').find('.blockwheels-accordion-content-wrap').not(dropDown).slideUp(400);
					if ($(this).hasClass('active')) {
						$(this).removeClass('active');
					} else {
						$(this).closest('.wp-block-blockwheels-accordion').find('.blockwheels-accordion-title-wrap.active').removeClass('active');
						$(this).addClass('active');
					}
					dropDown.stop(false, true).slideToggle(350);
					e.preventDefault();
				});
			});
		},
		// Initiate the menus when the DOM loads.
		init: function () {
			blockwheelsAccordion.initAll();
		},
	};

	if (document.readyState === "loading") {
		// The DOM has not yet been loaded.
		document.addEventListener("DOMContentLoaded", blockwheelsAccordion.init);
	} else {
		// The DOM has already been loaded.
		blockwheelsAccordion.init();
	}
})(jQuery);;